export default __webpack_public_path__ + "static/media/eshlFunktionsweise.931b6f5b.pdf";